export default __webpack_public_path__ + "static/media/02-hole-hi-sx.617dd78a.png";